/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Dashboard409ChartMetricSeriesQueryVariables = Exact<{
  tickers: Array<string> | string;
  metrics: Array<string> | string;
  start_date: string;
  end_date: string;
  interval_days?: number | null | undefined;
}>;


export type Dashboard409ChartMetricSeriesQuery = { metric_series: { unresolved_tickers: Array<string>, companies: Array<{ requested_identifier: string, data_points: Array<{ metric_key: string, requested_date: string, value: string | null }> }> } };

export type Dashboard409MetricSeriesPointFieldsFragment = { metric_key: string, requested_date: string, value: string | null };

export type Dashboard409SummaryMetricSeriesQueryVariables = Exact<{
  tickers: Array<string> | string;
  metrics: Array<string> | string;
  start_date: string;
  end_date: string;
  interval_days?: number | null | undefined;
}>;


export type Dashboard409SummaryMetricSeriesQuery = { metric_series: { unresolved_tickers: Array<string>, companies: Array<{ requested_identifier: string, company_name: string | null, data_points: Array<{ as_of_date: string | null, metric_key: string, requested_date: string, value: string | null }> }> } };

export type Dashboard409MetricsCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type Dashboard409MetricsCatalogQuery = { metrics_catalog: Array<{ metric_key: string, display_name: string, domain: string, unit: string | null, factor: string | null }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const Dashboard409MetricSeriesPointFieldsFragmentDoc = new TypedDocumentString(`
    fragment Dashboard409MetricSeriesPointFields on MetricSeriesPoint {
  metric_key
  requested_date
  value
}
    `, {"fragmentName":"Dashboard409MetricSeriesPointFields"}) as unknown as TypedDocumentString<Dashboard409MetricSeriesPointFieldsFragment, unknown>;
export const Dashboard409ChartMetricSeriesDocument = new TypedDocumentString(`
    query Dashboard409ChartMetricSeries($tickers: [String!]!, $metrics: [String!]!, $start_date: AWSDate!, $end_date: AWSDate!, $interval_days: Int) {
  metric_series(
    tickers: $tickers
    metrics: $metrics
    start_date: $start_date
    end_date: $end_date
    interval_days: $interval_days
  ) {
    companies {
      requested_identifier
      data_points {
        ...Dashboard409MetricSeriesPointFields
      }
    }
    unresolved_tickers
  }
}
    fragment Dashboard409MetricSeriesPointFields on MetricSeriesPoint {
  metric_key
  requested_date
  value
}`) as unknown as TypedDocumentString<Dashboard409ChartMetricSeriesQuery, Dashboard409ChartMetricSeriesQueryVariables>;
export const Dashboard409SummaryMetricSeriesDocument = new TypedDocumentString(`
    query Dashboard409SummaryMetricSeries($tickers: [String!]!, $metrics: [String!]!, $start_date: AWSDate!, $end_date: AWSDate!, $interval_days: Int) {
  metric_series(
    tickers: $tickers
    metrics: $metrics
    start_date: $start_date
    end_date: $end_date
    interval_days: $interval_days
  ) {
    companies {
      requested_identifier
      company_name
      data_points {
        ...Dashboard409MetricSeriesPointFields
        as_of_date
      }
    }
    unresolved_tickers
  }
}
    fragment Dashboard409MetricSeriesPointFields on MetricSeriesPoint {
  metric_key
  requested_date
  value
}`) as unknown as TypedDocumentString<Dashboard409SummaryMetricSeriesQuery, Dashboard409SummaryMetricSeriesQueryVariables>;
export const Dashboard409MetricsCatalogDocument = new TypedDocumentString(`
    query Dashboard409MetricsCatalog {
  metrics_catalog {
    metric_key
    display_name
    domain
    unit
    factor
  }
}
    `) as unknown as TypedDocumentString<Dashboard409MetricsCatalogQuery, Dashboard409MetricsCatalogQueryVariables>;